import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Menu, Container, Grid, Dropdown } from 'semantic-ui-react';
import { Route, Switch } from "react-router-dom";
import { withRouter } from 'react-router';

import SysadminClientPage from './client_page';
import SysadminClientAddPage from './client_add_page';
import SysadminClientUpdatePage from './client_update_page';
import SysadminUsersAddPage from './user_add_page';
import SysadminUsersListPage from './user_list_page';
import SysadminUserUpdatePage from './user_update_page';
import SysadminUserCreatePage from './user_create_page';
import SysadminUserDependentsPage from './user_dependents_page';
import SysadminAdminListPage from './admin_list_page';
import SysadminAdminCreatePage from './admin_create_page';
import SysadminAdminUpdatePage from './admin_update_page';

import SysadminHrclaimsListPage from './hrclaims_list_page';
import SysadminHrclaimsViewPage from './hrclaims_view_page';

import SysadminExcludedClinicsListPage from './excludedclinic_page';
import SysadminExcludedClinicCreatePage from './excludedclinic_create_page';

import SysadminAccountPage from './admin_account';
import { USER_TYPE, USER_ROLES } from '../../constants';
import CommonUtility from '../../utils/CommonUtility';
import InpatientListPage from './user_claim/Inpatient_list_page';
import InpatientViewPage from './user_claim/Inpatient_view_page';
import OutpatientListPage from './user_claim/outpatient_list_page';
import OutpatientViewPage from './user_claim/outpatient_view_page';
import VerifyUserBank from './verify_user_bank';
import VerifyInpatientBank from './verify_inpatient_bank';
import verifyOutpatientBank from './verify_outpatient_bank';
import JobListPage from "./job/job_list_page";

import { 
    doLogout 
} from '../../actions';

class SysadminIndexPage extends Component {
    state = {
        activeItem: 'clients'
    }

    componentDidMount() {
        const user = this.props.user;
        if ( !CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, user)) {
            if(this.props.history.location.pathname !== "/"){
                this.props.history.push('/');
            }
        }
    }

    renderMenuClaim(){
        return (
            <Dropdown item text='User Claims'>
                <Dropdown.Menu>
                    <Dropdown.Item name="userInpatient" onClick={this.handleItemClick}>Inpatient</Dropdown.Item>
                    <Dropdown.Item name="userOutpatient" onClick={this.handleItemClick}>Outpatient</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        )
    }

    handleItemClick = (event, values) => {
        this.setState({activeItem: values.name});
        if (values.name === 'logout') {
            this.props.doLogout();
            this.props.history.push('/');
        } else if (values.name === 'my plan editor') {
            window.open('/static/my_plan/MyPlanEditor.html');
        } else {
            const BASE_URL = '/systemadmin';
            const menuToUrl = {
                'clients': `${BASE_URL}`,
                'add client': `${BASE_URL}/client/create`,
                'users': `${BASE_URL}/user/list`,
                'admin': `${BASE_URL}/admin/list`,
                'system accounts': `${BASE_URL}/systemaccounts`,
                'add user': `${BASE_URL}/adduser`,
                'hr claims': `${BASE_URL}/hrclaims`,
                'bank detail': `${BASE_URL}/banks`,
                'excluded clinics': `${BASE_URL}/excludedclinic/list`,
                'userInpatient': `${BASE_URL}/userInpatient`,
                'userOutpatient': `${BASE_URL}/userOutpatient`,
                'verifyUserBank': `${BASE_URL}/verify/userbank`,
                'verifyInpatientBank': `${BASE_URL}/verify/inpatientBank`,
                'verifyOutpatientBank': `${BASE_URL}/verify/outpatientBank`,
                'job': `${BASE_URL}/job`,
            }
            this.props.history.push(menuToUrl[values.name]);
        }
    }

    renderMenuVerify(){
        const user = this.props.user;

        // check if SYS_ADMIN and ADMIN_ACCOUNT
        if( CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, user) && CommonUtility.haveRoles([USER_ROLES.ADMIN_ACCOUNT], user)){
            return (
                <Dropdown item text='Verification'>
                    <Dropdown.Menu>
                        <Dropdown.Item name="verifyUserBank" onClick={this.handleItemClick}>Verify User Bank</Dropdown.Item>
                        <Dropdown.Item name="verifyInpatientBank" onClick={this.handleItemClick}>Verify Inpatient Bank</Dropdown.Item>
                        <Dropdown.Item name="verifyOutpatientBank" onClick={this.handleItemClick}>Verify Outpatient Bank</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            )
        }
    }

    renderMenuExcludedClinics(){
        const user = this.props.user;
        const { activeItem } = this.state;

        // check if sys-admin
        if( CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, user) && CommonUtility.haveRoles([USER_ROLES.ADMIN_IT], user)){
            return (
                <Menu.Item
                    name='excluded clinics'
                    active={activeItem === 'excluded clinics'}
                    onClick={this.handleItemClick}
                />
            )
        }
    }

    render() {
        const { activeItem } = this.state;
        const { user } = this.props;
        const isAdminCreation = CommonUtility.haveRoles([USER_ROLES.ADMIN_CREATION], user)
        const isAdminIT = CommonUtility.haveRoles([USER_ROLES.ADMIN_IT], user)
        return (
            <Container>
                <Menu inverted>
                    <Menu.Item 
                        name='clients' 
                        active={activeItem === 'clients'} 
                        onClick={this.handleItemClick} 
                    />
                    <Menu.Item
                        name='users'
                        active={activeItem === 'users'}
                        onClick={this.handleItemClick}
                    />
                    { (isAdminIT || isAdminCreation) &&
                    <Menu.Item
                        name='admin'
                        active={activeItem === 'admin'}
                        onClick={this.handleItemClick}
                    />
                    }
                    <Menu.Item
                        name='my plan editor'
                        active={activeItem === 'my plan editor'}
                        onClick={this.handleItemClick}
                    />
                    <Menu.Item
                        name='hr claims'
                        active={activeItem === 'hr claims'}
                        onClick={this.handleItemClick}
                    />

                    {this.renderMenuClaim()}

                    {this.renderMenuVerify()}

                    {this.renderMenuExcludedClinics()}

                    <Menu.Item
                        name='job'
                        active={activeItem === 'job'}
                        onClick={this.handleItemClick}
                    />

                    <Menu.Item
                        name='logout'
                        active={activeItem === 'logout'}
                        onClick={this.handleItemClick}
                    />
                </Menu>
                <Grid>
                    <Grid.Column>
                        <Switch>
                            <Route exact path="/systemadmin" component={SysadminClientPage} />
                            <Route exact path="/systemadmin/client/create" component={SysadminClientAddPage} />
                            <Route exact path="/systemadmin/client/:clientId/update" component={SysadminClientUpdatePage} />
                            <Route exact path="/systemadmin/client/:clientId/users" component={SysadminUsersListPage} />
                            <Route exact path="/systemadmin/user/upload" component={SysadminUsersAddPage} />
                            <Route path="/systemadmin/user/list" component={()=>(<SysadminUsersListPage/>)} />
                            <Route path="/systemadmin/user/create" component={SysadminUserCreatePage} />
                            <Route path="/systemadmin/user/update" component={SysadminUserUpdatePage}/>
                            <Route path="/systemadmin/admin/list" component={()=>(<SysadminAdminListPage/>)} />
                            <Route path="/systemadmin/admin/create" component={SysadminAdminCreatePage} />
                            <Route path="/systemadmin/admin/update" component={SysadminAdminUpdatePage}/>
                            <Route exact path="/systemadmin/hrclaims" component={SysadminHrclaimsListPage} />
                            <Route exact path="/systemadmin/hrclaims/view/:hrclaimId" component={SysadminHrclaimsViewPage} />
                            <Route exact path="/systemadmin/verify/userbank" component={VerifyUserBank} />
                            <Route exact path="/systemadmin/verify/inpatientbank" component={VerifyInpatientBank} />
                            <Route exact path="/systemadmin/verify/outpatientbank" component={verifyOutpatientBank} />
                            <Route path="/systemadmin/excludedclinic/list" component={SysadminExcludedClinicsListPage} />
                            <Route path="/systemadmin/excludedclinic/create" component={SysadminExcludedClinicCreatePage} />
                            <Route path="/systemadmin/userinpatient/view" component={()=>(<InpatientViewPage/>)} />
                            <Route path="/systemadmin/userinpatient" component={()=>(<InpatientListPage/>)} />
                            <Route path="/systemadmin/userOutpatient/view" component={()=>(<OutpatientViewPage/>)} />
                            <Route path="/systemadmin/userOutpatient" component={()=>(<OutpatientListPage/>)} />
                            <Route path="/systemadmin/job" component={()=>(<JobListPage/>)} />
                        </Switch>
                    </Grid.Column>
                </Grid>
            </Container>
        );
    }
}

const mapStateToProps = (state) => {
    return { 
        user: state.user.user,
    };
}

export default withRouter(connect(mapStateToProps, {doLogout})(SysadminIndexPage));

/*
<Menu inverted>
    <Menu.Item 
        name='clients' 
        active={activeItem === 'clients'} 
        onClick={this.handleItemClick} 
    />
    <Menu.Item 
        name='add client' 
        active={activeItem === 'add client'} 
        onClick={this.handleItemClick} 
    />
    <Menu.Item
        name='users'
        active={activeItem === 'users'}
        onClick={this.handleItemClick}
    />
    <Menu.Item
        name='add user'
        active={activeItem === 'add user'}
        onClick={this.handleItemClick}
    />
    <Menu.Item
        name='system accounts'
        active={activeItem === 'system accounts'}
        onClick={this.handleItemClick}
    />
    <Menu.Item
        name='logout'
        active={activeItem === 'logout'}
        onClick={this.handleItemClick}
    />
</Menu>
*/